export const { REACT_APP_VENDOR_DASHBOARD_SERVICE, REACT_APP_SALESFORCE_URL } = process.env;
